import { render, staticRenderFns } from "./myAppointList.vue?vue&type=template&id=618c7a60&scoped=true"
import script from "./myAppointList.vue?vue&type=script&lang=js"
export * from "./myAppointList.vue?vue&type=script&lang=js"
import style0 from "./myAppointList.vue?vue&type=style&index=0&id=618c7a60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c7a60",
  null
  
)

export default component.exports